<template>
  <div v-if="emailTemplates?.length">
    <div :class="$style.inner">
      <TemplatePreview
        v-for="(template, index) in emailTemplates"
        :key="index"
        :template="template"
      />
    </div>
  </div>
</template>

<script lang="ts">
import gql from 'graphql-tag';
import { defineComponent } from 'vue';
import TemplatePreview from './TemplatePreview.vue';

export default defineComponent({
  name: 'EmailTemplatesOverview',
  components: {
    TemplatePreview,
  },
  apollo: {
    emailTemplates: {
      query: gql`
        query getEmailTemplates($emailType: EmailTemplateEnum!) {
          emailTemplates(emailType: $emailType) {
            color
            hasImage
            hasDeliverySchedule
            deliverAt
            id
            imageUrl
            name
            subject
            emailType
          }
        }
      `,
      variables: {
        emailType: 'MARKETING_CAMPAIGN',
      },
      fetchPolicy: 'cache-and-network',
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.inner {
  display: flex;
  flex-wrap: wrap;
  margin: $spacing * 0.5 (-$spacing * 0.5) (-$spacing * 0.5);
}
</style>
